module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Praise for John A. Daly and "), _c('i', [_vm._v("From a Dead Sleep")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "tx1"
  }, [_vm._v("Some writers are thoughtful. Some have style. John Daly has both. When I read his work, it’s time well spent.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('b', [_vm._v("— Bernard Goldberg, "), _c('i', [_vm._v("New York Times")]), _vm._v(" bestselling author of "), _c('i', [_vm._v("Bias")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1-1"
  }, [_vm._v("An epic thriller with a memorable, unorthodox main character . . . a riveting read . . .")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('b', [_c('i', [_vm._v("— Colorado Country Life Magazine")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1-1"
  }, [_vm._v("A fast-reading suspense book that surprised me so much, I had to finish it in one sitting.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('b', [_vm._v("— Alice de Sturler of the American Investigative Society of Cold Cases")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1-1"
  }, [_vm._v("A thriller that packs a punch! This was a very exciting debut novel from John A. Daly. This novel packs a lot of jaw-dropping action into its well-structured narrative—a narrative that gives life to the myriad of characters that inhabit its pages and provides plenty of plot twists and turns to keep you glued to the pages.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('b', [_vm._v("— Reading, Writing, and Riesling book blog")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1-1"
  }, [_vm._v("I loved this book. The suspense had me sitting on the edge of my seat . . . The author did a fabulous job with the setting details—I could picture every touch, smell, sight that the characters went through . . .")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('b', [_vm._v("— Yawatta Hosby, author of the novel "), _c('i', [_vm._v("One by One")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1-1"
  }, [_c('i', [_vm._v("From a Dead Sleep")]), _vm._v(" is a page-turner, an exciting, well-written thriller with a solid back story and more than enough plot twists to keep you guessing.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('b', [_vm._v("— Marilyn Armstrong, Serendipity book blog")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a63f90aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter03.vue
// module id = 69
// module chunks = 0